import { API } from '@/api';
import { CLEAR_READ_FILTER } from './constants';

export const classes = {
  clearAll: 'text-red-2',
};

export function readAllNotifications() {
  return API.Notifications.updateAllNotifications({ isRead: true });
}

export function clearReadNotifications() {
  return API.Notifications.removeAllNotifications(CLEAR_READ_FILTER);
}

export function clearAllNotifications() {
  return API.Notifications.removeAllNotifications();
}
